export default {
  agent: 'Become a distributor of 4D KanKan',
  agentIntro: '4D KanKan is committed to build an ecosystem of “digital everything”, so that everyone can  experience and enjoy the convenience of AI computer vision. <br/>We invite you to join our distributor team and become one of us.',
  project: {
    title: 'Outline of 4D KanKan Distributor Program',
    label:
      'The patented AI space reconstruction algorithm technology from 4DAge has won numerous awards and has reconstructed more than 300,000 space models worldwide.<br/>This innovative approach of space reconstruction is gradually changing the business model of various industries (real estate, architecture, museum, tourism, jounalist, insurance claims, criminal investigation, etc.).<br/>Our 4D KanKan Distributor Program invites professionals from all industries to participate in our “Digital Everything” scheme, open up new market together and share profits.<br/>If you are interested in the idea of ​​3D capturing the world and would like to incorporate it into your career plan, this is an excellent opportunity for cooperation.'
  },
  benefit: 'Benefits of Being our Valued Distributor',
  benefitGroup: [
    {
      fontImg: 'icon-lirunfencheng',
      title: 'Share the Profit',
      sub: 'Large Profit to Share'
    },
    {
      fontImg: 'icon-zhuanshukefu',
      title: 'Exclusive Customer Service',
      sub: 'Support from Exclusive and Professional Sales and Technicians'
    },
    {
      fontImg: 'icon-xuanchuanziliao',
      title: 'Promotional Material',
      sub: 'Regularly Updated Promotional Videos and Cases'
    },
    {
      fontImg: 'icon-dianmianbuzhi',
      title: 'Shop Decoration',
      sub: 'Offer Necessary Promotional Material for the Shop'
    },
    {
      fontImg: 'icon-fazhanjihui',
      title: 'Growth Opportunity',
      sub: 'Opportunities to Join Exhibitions and Professional Conferences'
    }
  ],
  jingxiaoshang: {
    title: 'Become a distributor of 4D KanKan',
    companytitle: 'Company Information',
    company: {
      name: {
        title: 'Registered Company Name',
        placeholder: 'Please input the registered company name'
      },
      address: {
        title: 'Company Address',
        placeholder: 'Country',
        placeholder2: 'Region',
        placeholder3: 'Please input the detailed address of your company'

      },
      store: {
        title: 'Do you have a retail shop or a company website?',
        type1: 'Mainly Offline Sales',
        type2: 'Mainly Online Sales',
        placeholder: 'Please input the detailed address of your retail shop'
      }
    },
    applytitle: 'Applicant Information',
    apply: {
      name: {
        xing: 'Last Name',
        ming: 'First Name',
        placeholder: 'Please input the last name',
        placeholder1: 'Please input the first name'
      },
      position: {
        title: 'Title',
        placeholder: 'Please input the title'
      },
      phone: {
        title: 'Phone',
        placeholder: 'Please input the phone'
      },
      email: {
        title: 'Email',
        placeholder: 'Please input the email'
      }
    }
  },
  submit: 'Submit'
}



// WEBPACK FOOTER //
// ./src/store/language/en/agent.js